import { UnionMap } from '../../../types/union-map';

export type RepairOperationResultOutcome = 'FixApplied' | 'IssuesDetected' | 'NoIssuesDetected';

export const RepairOperationResultOutcome: UnionMap<RepairOperationResultOutcome> = {
    FixApplied: 'FixApplied',
    IssuesDetected: 'IssuesDetected',
    NoIssuesDetected: 'NoIssuesDetected',
};

export type DevBoxCardInfoBannerMessageKind =
    | 'RepairOperationInProgressMessage'
    | 'TakeSnapshotOperationInProgressMessage'
    | 'RestoreOperationInProgressMessage'
    | 'CustomizeOperationInProgressMessage'
    | 'WaitingForUserSessionMessage'
    | 'NoIssuesDetectedMessage'
    | 'OffloadDevBoxMessage'
    | 'MoveOperationInProgressMessage'
    | 'None';

export const DevBoxCardInfoBannerMessageKind: UnionMap<DevBoxCardInfoBannerMessageKind> = {
    RepairOperationInProgressMessage: 'RepairOperationInProgressMessage',
    TakeSnapshotOperationInProgressMessage: 'TakeSnapshotOperationInProgressMessage',
    RestoreOperationInProgressMessage: 'RestoreOperationInProgressMessage',
    CustomizeOperationInProgressMessage: 'CustomizeOperationInProgressMessage',
    WaitingForUserSessionMessage: 'WaitingForUserSessionMessage',
    NoIssuesDetectedMessage: 'NoIssuesDetectedMessage',
    OffloadDevBoxMessage: 'OffloadDevBoxMessage',
    MoveOperationInProgressMessage: 'MoveOperationInProgressMessage',
    None: 'None',
};

export type DevBoxCardSuccessBannerMessageKind =
    | 'SkipStateSuccessMessage'
    | 'DelayStateSuccessMessage'
    | 'DelayStateDayAfterNextSuccessMessage'
    | 'DelayStateNextDaySuccessMessage'
    | 'IssuesFixedMessage'
    | 'None';

export const DevBoxCardSuccessBannerMessageKind: UnionMap<DevBoxCardSuccessBannerMessageKind> = {
    SkipStateSuccessMessage: 'SkipStateSuccessMessage',
    DelayStateSuccessMessage: 'DelayStateSuccessMessage',
    DelayStateDayAfterNextSuccessMessage: 'DelayStateDayAfterNextSuccessMessage',
    DelayStateNextDaySuccessMessage: 'DelayStateNextDaySuccessMessage',
    IssuesFixedMessage: 'IssuesFixedMessage',
    None: 'None',
};

export type DevBoxStatusImageKind = 'Running' | 'Stopped' | 'Stopping';

export const DevBoxStatusImageKind: UnionMap<DevBoxStatusImageKind> = {
    Running: 'Running',
    Stopped: 'Stopped',
    Stopping: 'Stopping',
};
